
import { defineComponent, computed, defineExpose, ref, onMounted } from "vue";
import type { ITeachersModel, IJourneysModel, IHeadquartersModel } from "@/interfaces/modules";
import JourneysService from "@/api/Configuration/JourneysService";
import HeadquartersService from "@/api/Configuration/HeadquartersService";

export default defineComponent({
  name: "TabContractTeacher",
  props: {
    record: { type: Object as () => ITeachersModel, required: true },
    wasValidated: { type: Boolean, default: false }
  },
  emits: ["update:record"],
  setup(props, { emit }) {
    const recordProxy = computed<ITeachersModel>({
      get: () => props.record,
      set: (val) => emit("update:record", val),
    });

    const Journeys = ref<IJourneysModel[]>([]);
    const Headquarters = ref<IHeadquartersModel[]>([]);
    // … your existing options/state …
    const SchoolLevels = ref<[]>([]);
    const EducationLevels = ref<[]>([]);
    const TeachingAreas = ref<[]>([]);

    const updateField = (key: keyof ITeachersModel, value: any) => {
      recordProxy.value = { ...recordProxy.value, [key]: value };
    };
    const toNumber = (v: any) => (v === "" || v === null || v === undefined ? null : Number(v));
    // Exponer validate() si el padre quiere validación adicional
    const validate = () => ({ ok: true });
    defineExpose({ validate });

    const load = async () => {
      Journeys.value = await JourneysService.GetJourneys();
      Headquarters.value = await HeadquartersService.GetHeadquarters();
    };

    onMounted(load);

    return {
      recordProxy, 
      updateField, 
      Journeys, 
      Headquarters, 
      toNumber,
      EducationLevels,
      TeachingAreas,
      SchoolLevels
    };
  },
});
